export default [
  {
    label: 'Search phrase',
    value: 'search_phrase',
  }, {
    label: 'Promotion url',
    value: 'promotion_url',
  },
];
